import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroVenue from "../components/Hero_venue";
import ProfileCards from "../components/ProfileCard";
import profileImage_dw from "../assets/dave_wright.jpeg";
import profileImage_pw from "../assets/pawel_wojtas.jpeg";
import profileImage_ks from "../assets/Karen_Sweetman_Hicks.jpeg";
import profileImage_pk from "../assets/Paul_Kendall.jpeg";
import profileImage from "../assets/empty_team_profile-01.jpg";
import heroImage from "../assets/teams_hero.jpeg";
import profileImage_ES from "../assets/Erin_photo_website.jpg";
import profileImage_am from "../assets/Xander_photo_website.jpg";
import profileImage_ms from "../assets/Mark_photo_website.jpg";
import profileImage_rs from "../assets/Richard_Salloum.jpg";
import Canonical from "../components/canonical";

export function Team() {
  return (
    <React.Fragment>
      <Canonical />
      <Navbar linkName="Home" />
      <HeroVenue heroAreaName="Team" imageSrc={heroImage} />
      <div className="bg-[#075AAA] w-full mx-auto flex flex-col items-center justify-center text-white">
        <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center  ">
          <h1>Our Team</h1>
        </div>
        <div className="max-w-[1248px] flex flex-wrap gap-x-4 pb-4 text-center">
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            <span className="font-bold">
              All instructors are national governing body qualified and
              authorised, all with the necessary qualifications and insurance
            </span>
            <br /> <br />
            We believe in leading from the front and show both technical and
            working judo. If you have any questions, please talk to any of us.
            We run the club for our member's benefit.
          </p>
        </div>
      </div>
      <div className="uppercase my-8 mx-4  md:text-4xl text-xl sm:text-2xl font-bold items-start text-center text-[#01184D] ">
        <h1>TREASURER</h1>
      </div>
      <div className="flex flex-wrap justify-center items-center gap-4 md:flex-row flex-col mx-4">
        <ProfileCards
          headerText="Paul Kendall"
          imgSrc={profileImage_pk}
          alt="Paul Kendall"
        >
          <h1 className="text-xl sm:text-2xl md-3xl font-bold">Paul Kendall</h1>
          <h3 className="text-lg sm:text-xl md-2xl">1 st Dan</h3>
          <p>
            Paul has been doing judo for over 20 years. He has a collection of
            medals from different competitions, and has also trained under high
            level dan grades at different courses. He was also a qualified
            Instructor for a number of years.
          </p>
        </ProfileCards>
      </div>
      <div className="uppercase my-8 mx-4  md:text-4xl text-xl sm:text-2xl font-bold items-start text-center text-[#01184D] ">
        <h1>WELFARE OFFICER </h1>
      </div>
      <div className="flex flex-wrap justify-center items-center gap-4 md:flex-row flex-col mx-4">
        <ProfileCards
          headerText="Zack Hughes-Burton"
          imgSrc={profileImage}
          alt="Zack Hughes-Burton"
        >
          <h1 className="text-xl sm:text-2xl md-3xl font-bold">
            Zack Hughes-Burton
          </h1>
          <h3 className="text-lg sm:text-xl md-2xl">
            Zack is the Welfare Officer for Worthing Leisure Centre
          </h3>
        </ProfileCards>
      </div>
      <div className="uppercase my-8 mx-4  md:text-4xl text-xl sm:text-2xl font-bold items-start text-center text-[#01184D] ">
        <h1>Assistant Club Instructor</h1>
      </div>
      <div className="flex flex-wrap justify-center items-center gap-4 md:flex-row flex-col mx-4">
        <ProfileCards
          headerText="Karen Sweetman-Hicks"
          imgSrc={profileImage_ks}
          alt="Karen Sweetman-Hicks"
        >
          <h1 className="text-xl sm:text-2xl md-3xl font-bold">
            Karen Sweetman-Hicks
          </h1>
          <h3 className="text-lg sm:text-xl md-2xl">1st Dan</h3>
          <p>
            Karen began judo as a junior and has many years’ experience of
            practising and teaching judo.
          </p>
        </ProfileCards>
        <ProfileCards
          headerText="Alexander Munro"
          imgSrc={profileImage_am}
          alt="Alexander Munro Picture"
        >
          <h1 className="text-xl sm:text-2xl md-3xl font-bold">
            Alexander Munro 1st Dan
          </h1>
          <h3 className="text-lg sm:text-xl md-2xl">1st Dan</h3>
          <p>
            Xander gained his black belt at the age of 17, due to a combination
            of ability, technical skill, and dedication to training.
          </p>
        </ProfileCards>
        <ProfileCards
          headerText="Mark Sexton"
          imgSrc={profileImage_ms}
          alt="Mark Sexton"
        >
          <h1 className="text-xl sm:text-2xl md-3xl font-bold">
            Mark Sexton BA (Hons) 1st Kyu
          </h1>
          <h3 className="text-lg sm:text-xl md-2xl">1st Dan</h3>
          <p>
            Mark has an excellent knowledge of both technical and working judo.
            He also holds the same grade in karate.
          </p>
        </ProfileCards>
        <ProfileCards
          headerText="Richard Salloum"
          imgSrc={profileImage_rs}
          alt="Richard Salloum"
        >
          <h1 className="text-xl sm:text-2xl md-3xl font-bold">
            Richard Salloum 1st Kyu
          </h1>
          <h3 className="text-lg sm:text-xl md-2xl"></h3>
          <p>
            Richard has an excellent knowledge of both technical and working
            judo, having exceeded the pass mark in each of his previous grades.
            He has achieved his brown belt quickly by consistent attendance and
            hard work, and has now qualified as an instructor, joining the team.
            He is committed to achieving his black belt.
          </p>
        </ProfileCards>
      </div>
      <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center text-[#01184D] ">
        <h1>Club Owners and Management</h1>
      </div>
      <div className="flex flex-wrap justify-center items-center gap-4 md:flex-row flex-col mx-4 pb-8">
        <ProfileCards
          headerText="Pawel Wojtas MA"
          imgSrc={profileImage_pw}
          alt="Pawel Wojtas MA"
        >
          <h1 className="text-xl sm:text-2xl md-3xl font-bold">
            Pawel Wojtas MA
          </h1>
          <h3 className="text-lg sm:text-xl md-2xl">1 st Dan</h3>
          <p>
            Pawel has been practising judo for over 30 years and is a former
            Polish National Junior bronze medallist. He has competed in many
            competitions across Europe, winning many regional events. He has
            also won a 5 th place at the Polish University Championships. In
            England, he is a former Sussex and a Southern Area medallist.
          </p>
        </ProfileCards>
        <ProfileCards
          headerText="Erin Southam BA (Hons)"
          imgSrc={profileImage_ES}
          alt="Erin Southam BA (Hons)"
        >
          <h1 className="text-xl sm:text-2xl md-3xl font-bold">
            Erin Southam BA (Hons)
          </h1>
          <h3 className="text-lg sm:text-xl md-2xl">2nd Dan</h3>
          <p>
            Erin has been practising judo for over 30 years. Having a degree in
            PE &amp; Sports, she is also a qualified coach in other sports. She
            has won many judo competitions at both junior and senior level over
            a 20-year period. She has represented Sussex County at the annual
            Inter Counties Championships and is a former Southern Area gold
            medallist.
          </p>
        </ProfileCards>
        <ProfileCards
          headerText="Dave Wright"
          imgSrc={profileImage_dw}
          alt="Dave Wright"
        >
          <h1 className="text-xl sm:text-2xl md-3xl font-bold">Dave Wright</h1>
          <h3 className="text-lg sm:text-xl md-2xl">4th Dan</h3>
          <p>
            Dave has been practising judo for over 40 years. He is a former
            Sussex Open gold and silver medallist, and also a National Masters
            gold and silver medallist. After a 15-year competitive period, he
            then spent 12 years as a Sussex County Squad Instructor. He also
            took elite players three times a year to Olympic TeamBath University
            to have personal and group tuition from the Olympic coach, and train
            alongside their players.
          </p>
        </ProfileCards>
      </div>

      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
